import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, articles, faqs, stats, features, memberBenefits, reputations } from '@/mocks/data';

function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20cinematic%20dark%20theater%20interior%20with%20warm%20accent%20lighting%2C%20abstract%20flowing%20gradients%20of%20deep%20crimson%20and%20charcoal%2C%20elegant%20curved%20lines%2C%20premium%20entertainment%20atmosphere%2C%20sophisticated%20minimalist%20composition%2C%20dramatic%20spotlight%20effects%20on%20dark%20background&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="撸撸社官网 - 官方正版入口"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          撸撸社官网 - 官方正版入口
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          撸撸社官网是用户信赖的官方平台，提供正版内容、安全登录入口及完整会员服务。
          享受<strong>高清资源</strong>、<strong>极速播放</strong>与<strong>全天候客服支持</strong>，立即注册体验专属会员权益。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即注册
          </Link>
          <Link
            to="/category/hot"
            className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold border-2 border-white/30 text-white rounded-md hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览内容
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-8 flex-wrap">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            为什么选择撸撸社官网
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            撸撸社官方网站致力于为用户提供最优质的娱乐体验，六大核心优势让您畅享无忧
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200/50 transition-all duration-300 group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            内容分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            撸撸社官网拥有丰富的分类内容，满足您的多样化观影需求
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center hover:border-primary-300 hover:shadow-sm transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function PopularSection() {
  const popularArticles = articles.filter((a) => a.category === 'hot').slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门内容推荐
            </h2>
            <p className="text-sm text-foreground-600">撸撸社官网精选热门内容，每日更新</p>
          </div>
          <Link
            to="/category/hot"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {popularArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full">
                    {categories.find((c) => c.slug === article.category)?.name}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2">{article.description}</p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </div>
                  <span>{article.views.toLocaleString()} 次浏览</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/hot"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}

function MemberSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            会员专属权益
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            成为撸撸社会员，解锁八大专属权益，开启极致观影体验
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {memberBenefits.map((benefit, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center hover:border-accent-300 transition-all duration-300 group cursor-default"
            >
              <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${benefit.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{benefit.title}</h3>
              <p className="text-xs text-foreground-500">{benefit.desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="inline-block px-8 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即开通会员
          </Link>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于撸撸社官网的常见问题解答
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

import { useState } from 'react';

function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20background%20with%20warm%20gradients%20of%20deep%20amber%20and%20charcoal%2C%20abstract%20flowing%20motion%20lines%2C%20theater%20atmosphere%2C%20elegant%20and%20sophisticated%20composition%20with%20soft%20spotlight%20effects&width=1920&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          加入撸撸社，开启极致观影之旅
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-lg mx-auto">
          500万+用户的共同选择，立即注册撸撸社官网，畅享高清资源与极速播放体验
        </p>
        <Link
          to="/about"
          className="inline-block px-8 py-3.5 text-base font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          免费注册撸撸社
        </Link>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularSection />
        <MemberSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}